import { defaultState, ConfigReducer } from './defaultState'
import * as actionTypes from '../../constants/actionTypes'
import { setupTypes } from '../../actions/setup/setupTypes'
import { syncType } from '../../actions/sync'
import { init } from '../../../lib/audit'
import { createReducer } from '@reduxjs/toolkit'
import { UIType } from '../../actions/ui/uiTypes'
import { roomTypes } from '../../actions/room/roomTypes'
import { DocsType } from '../../actions/docs/docsTypes'

export default createReducer<ConfigReducer>(defaultState, {

  [actionTypes.SET_ROLE]: (state, { payload }) => {

    state.role = payload.role
    state.username = payload.username

  },
  [actionTypes.SET_ROOMNAME]: (state, { payload }) => {

    init(payload)
    state.roomname = payload

  },
  [actionTypes.SET_USER]: (state, { payload }) => {

    state.username = payload

  },
  [actionTypes.SET_ROOM_AND_USER]: (state, { payload }) => {

    state.username = payload.username
    state.role = payload.role
    state.roomname = payload.roomname

  },
  [actionTypes.TOKEN_FETCH]: (state) => {

    state.isFetchingToken = true
    state.token = null
    state.hasErrorToken = false

  },
  [actionTypes.TOKEN_SUCCESS]: (state, { payload }) => {

    state.isFetchingToken = false
    state.token = payload

  },
  [syncType.TOKEN_RENEWAL_SUCCESS]: (state, { payload }) => {

    state.isFetchingToken = false
    state.token = payload

  },
  [actionTypes.TOKEN_ERROR]: (state) => {

    state.isFetchingToken = false
    state.hasErrorToken = true

  },
  [DocsType.RESET_SESSION]: (state) => {

    return defaultState

  },
  [setupTypes.SEND_DEBUG_STATS]: (state, { payload }) => {

    state.stats = payload

  },
  [roomTypes.NETWORK_QUALITY_CHANGE]: (state, { payload }) => {

    state.networkQuality = payload

  },
  [setupTypes.SET_DEBUG]: (state) => {

    state.debug = true

  },
  [actionTypes.SET_LOCAL_BRIDGE]: (state, {payload}) => {

    state.isLocalBridge = payload
  },
  [actionTypes.SET_HOST]: (state, { payload }) => {

    state.host = payload

  },
  [actionTypes.SET_CHANNEL_AND_WEBCAST]: (state, { payload }) => {

    state.channelId = payload.channelId
    state.webcastId = payload.webcastId

  },
  [actionTypes.SET_AVAILABLE_DEVICES]: (state, { payload }) => {

    state.inputDevices = payload

  },
  [roomTypes.SET_DEVICE_PERMISSIONS]: (state, { payload }) => {

    state.devicePermissions = payload

  },
  [setupTypes.SET_GIG_OPTIONS]: (state, { payload }) => {

    state.gigOptions = payload

  },
  [UIType.SET_FEATURE_FLAG]: (state, { payload }) => {

    state.featureFlags[payload.feature] = payload.value

  },
  [setupTypes.SET_AVAILABLE_FEATURES]: (state, { payload }) => {

    const featureObj = { ...state.featureFlags }
    const incomingFeatureObj = {}

    payload.forEach((feature: { featureName: string, enabled: boolean }) =>
      incomingFeatureObj[feature.featureName] = feature.enabled)

    for (const key in incomingFeatureObj) {
      if (Object.hasOwnProperty.call(incomingFeatureObj, key)) {
        featureObj[key] = incomingFeatureObj[key]
      }
    }

    state.featureFlags = featureObj

  },
  [setupTypes.SET_BRIDGE_NAME]: (state, { payload }) => {

    state.bridgeName = payload

  },
  [setupTypes.SET_ACTIVE_BRIDGE]: (state, { payload }) => {

    state.activeBridge = payload

  },
  [setupTypes.SET_SERVICED_OPTION]: (state) => {

    state.serviced = true

  },
  [setupTypes.SET_CAN_USER_PRESENT]: (state, { payload }) => {

    state.userCanPresent = payload

  },
  [setupTypes.SET_USER_HAS_CHANNEL_ROLES]: (state, { payload }) => {

    state.userHasChannelRoles = payload

  }

})
